import { BareContent, Content } from '@go-shared/types/content';
import { BareContentTemplate } from '@go-shared/types/contentTemplate';
import { Day } from '@go-shared/types/time';

export function bare(content: Content): BareContent {
  return {
    ...content,
    day: content.day._id,
    template: content.template._id,
  };
}

export function populate(content: BareContent, template: BareContentTemplate, day: Day): Content {
  return {
    ...content,
    template,
    day,
  };
}
